import { Component, OnInit } from '@angular/core';
import {AchatService} from '../../../../../../services/achat/achat.service';

@Component({
  selector: 'app-paye-fac-f',
  templateUrl: './paye-fac-f.component.html',
  styleUrls: ['./paye-fac-f.component.scss']
})
export class PayeFacFComponent implements OnInit {

    constructor(private dataService: AchatService) {}

    ngOnInit(): void {
        this.dataService.filterFactureFournisseurByStatus('Payé');
    }

}
